import { StyleSheet, View } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const HomeDivider = () => {
  return <View style={styles.divider} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const dividerColor = 'rgba(0, 0, 0, 0.05)';
const styles = StyleSheet.create({
  divider: {
    height: 1,
    backgroundColor: dividerColor,
  },
});
